export default __webpack_public_path__ + "static/media/MEMORIAN.99f58f86.svg";